export const actionPrimaryColors = [
	{
		cssVariableMapping: 'color-action-primary-default',
		value: 'var(--color-brand-primary)',
	},
	{
		cssVariableMapping: 'color-action-primary-hover',
		value: 'var(--color-brand-primary-darken-2)',
	},
	{
		cssVariableMapping: 'color-action-primary-active',
		value: 'var(--color-brand-primary-darken-3)',
	},
	{
		cssVariableMapping: 'color-action-primary-disabled',
		value: 'var(--color-brand-primary-lighten-3)',
	},
	{
		cssVariableMapping: 'color-action-primary-hover-lighten',
		value: 'var(--color-brand-primary-lighten-5)',
	},
	{
		cssVariableMapping: 'color-action-primary-active-lighten',
		value: 'var(--color-brand-primary-lighten-4)',
	},
	{
		cssVariableMapping: 'color-action-primary-inverted',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-primary-inverted-hover',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-primary-inverted-disabled',
		value: 'var(--color-neutral-0)',
	},
];

export const actionSecondaryColors = [
	{
		cssVariableMapping: 'color-action-secondary-default',
		value: 'var(--color-brand-secondary)',
	},
	{
		cssVariableMapping: 'color-action-secondary-hover',
		value: 'var(--color-brand-secondary-darken-2)',
	},
	{
		cssVariableMapping: 'color-action-secondary-active',
		value: 'var(--color-brand-secondary-darken-3)',
	},
	{
		cssVariableMapping: 'color-action-secondary-disabled',
		value: 'var(--color-brand-secondary-lighten-3)',
	},
	{
		cssVariableMapping: 'color-action-secondary-hover-lighten',
		value: 'var(--color-brand-secondary-lighten-5)',
	},
	{
		cssVariableMapping: 'color-action-secondary-active-lighten',
		value: 'var(--color-brand-secondary-lighten-4)',
	},
	{
		cssVariableMapping: 'color-action-secondary-inverted',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-secondary-inverted-hover',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-secondary-inverted-disabled',
		value: 'var(--color-neutral-0)',
	},
];

export const actionNeutralColors = [
	{
		cssVariableMapping: 'color-action-neutral-default',
		value: 'var(--color-neutral-5)',
	},
	{
		cssVariableMapping: 'color-action-neutral-hover',
		value: 'var(--color-neutral-7)',
	},
	{
		cssVariableMapping: 'color-action-neutral-active',
		value: 'var(--color-neutral-8)',
	},
	{
		cssVariableMapping: 'color-action-neutral-disabled',
		value: 'var(--color-neutral-3)',
	},
	{
		cssVariableMapping: 'color-action-neutral-hover-lighten',
		value: 'var(--color-neutral-1)',
	},
	{
		cssVariableMapping: 'color-action-neutral-active-lighten',
		value: 'var(--color-neutral-2)',
	},
	{
		cssVariableMapping: 'color-action-neutral-inverted',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-neutral-inverted-hover',
		value: 'var(--color-neutral-0)',
	},
	{
		cssVariableMapping: 'color-action-neutral-inverted-disabled',
		value: 'var(--color-neutral-0)',
	},
];